import { isEmpty, includes } from 'lodash';

let controlPointRatio = 14;
let pixelToMmRatio = 7.874;
let taskPinSizeRatio = 0.5;

export const handleBeforeRender = (viewer, canvas) => {
  const { viewport, source } = viewer;

  if (viewer.source) {
    let planWidth = source.width;
    let planHeight = source.height;

    const c = viewport.getContainerSize();
    const wr = planWidth / c.x;
    const rr = wr;
    taskPinSizeRatio = rr / 20;
    controlPointRatio = rr * 1.8;
  }

  const zoom = viewport.getZoom();
  const w = (pixelToMmRatio / zoom) * controlPointRatio;

  const objects = canvas.getObjects();

  for (let i = 0; i < objects.length; i++) {
    const obj = objects[i];
    if (obj.objectType === 'controlpoint' && !obj.isTemporary) {
      obj.set({
        left: obj.left + obj.width / 2 - w / 2,
        top: obj.top + obj.height / 2 - w / 2,
        width: w,
        height: w,
        strokeWidth: w / 20,
      });
    }

    if (includes(['task', 'plan', 'specification'], obj.objectType)) {
      obj.scaleX = (pixelToMmRatio / zoom) * taskPinSizeRatio;
      obj.scaleY = (pixelToMmRatio / zoom) * taskPinSizeRatio;

      if (
        !canvas.getActiveObject() ||
        canvas.getActiveObject().type !== 'activeSelection'
      ) {
        obj.left =
          obj.originalLeft -
          (((obj.width / 2) * pixelToMmRatio) / zoom) * taskPinSizeRatio;
        obj.top =
          obj.originalTop -
          ((obj.height * pixelToMmRatio) / zoom) * taskPinSizeRatio;
      }

      obj.setCoords();
    }
  }
};

export const clampObjectPosition = (obj, viewer, source) => {
  const { viewport } = viewer;

  obj.setCoords();

  if (includes(['task', 'plan', 'specification'], obj.objectType)) {
    const zoom = viewport.getZoom();
    const scale = (pixelToMmRatio / zoom) * taskPinSizeRatio;

    obj.originalLeft = obj.left + (obj.width * scale) / 2;
    obj.originalTop = obj.top + obj.height * scale;

    const width = obj.width * scale;
    const height = obj.height * scale;

    if (obj.originalLeft < width / 2) {
      obj.originalLeft = width / 2;
    }
    if (obj.originalLeft > source.width - width / 2) {
      obj.originalLeft = source.width - width / 2;
    }
    if (obj.originalTop < height) {
      obj.originalTop = height;
    }
    if (obj.originalTop > source.height) {
      obj.originalTop = source.height;
    }

    obj.set({
      left: obj.originalLeft - width / 2,
      top: obj.originalTop - height,
    });
  } else {
    const bounds = obj.getBoundingRect(true);

    if (
      bounds.left < 0 ||
      bounds.top < 0 ||
      bounds.left + bounds.width > source.width ||
      bounds.top + bounds.height > source.height
    ) {
      obj.scaleX = obj.lastGoodScaleX ?? 1;
      obj.scaleY = obj.lastGoodScaleY ?? 1;
      obj.left = obj.lastGoodLeft ?? obj.left;
      obj.top = obj.lastGoodTop ?? obj.top;
    } else {
      obj.lastGoodLeft = obj.left;
      obj.lastGoodTop = obj.top;
      obj.lastGoodScaleX = obj.scaleX;
      obj.lastGoodScaleY = obj.scaleY;
    }

    obj.setCoords();
  }
};
